/* Kilat 4U: "swap for the set" (cart offer, "Add the set" on bottle pages): adds the set and takes out one of each single bottle it replaces, so nothing is bought twice.
   Button: data-k4u-setswap, data-variant-id, data-quantity, data-parts (bottle variant ids), data-line-key (a line to drop whole: the washer being upgraded). Cart events as in k4u.js. */
const H = { 'Content-Type': 'application/json', Accept: 'application/json' };
const T = () => (typeof Theme !== 'undefined' && Theme.routes) || {};   // Theme is a top-level const of snippets/scripts.liquid: visible by name, not as window.Theme
const post = (url, body) => fetch(url, { method: 'POST', headers: H, body: JSON.stringify(body) }).then((r) => r.json().then((data) => ({ ok: r.ok, data })));
const getCart = () => fetch(`${T().cart_url || '/cart'}.json`, { headers: { Accept: 'application/json' } }).then((r) => r.json());

document.addEventListener('click', async (event) => {
  const b = event.target instanceof Element ? event.target.closest('[data-k4u-setswap]') : null;
  if (!b || b.disabled) return;
  event.preventDefault();
  const { variantId, productId, lineKey } = b.dataset;
  const quantity = Number(b.dataset.quantity) || 1;
  const parts = (b.dataset.parts || '').split(',').filter(Boolean);
  const change = (id, qty) => post(`${T().cart_change_url || '/cart/change'}.js`, { id, quantity: qty });
  b.disabled = true;
  b.setAttribute('aria-busy', 'true');
  const Ev = await import('@shopify/events').then((m) => m.CartLinesUpdateEvent, () => null);
  const deferred = Ev?.createPromise();
  Ev && b.dispatchEvent(new Ev({ action: 'add', context: 'cart', lines: [{ merchandiseId: String(variantId), quantity }], promise: deferred.promise }));
  try {
    const before = await getCart();
    const added = await post(T().cart_add_url || '/cart/add.js', { items: [{ id: Number(variantId), quantity }] });   // the set goes in first: a sold-out set takes nothing out
    if (added.ok) {
      if (lineKey) await change(lineKey, 0);
      for (const l of before.items) if (l.key !== lineKey && parts.includes(String(l.variant_id)) && !l.properties?._build) await change(l.key, Math.max(0, l.quantity - quantity));   // a builder line keeps its bottles
    }
    const cart = await getCart();
    if (Ev) deferred.resolve({ cart: Ev.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'k4u-swap', sourceId: 'k4u-swap', itemCount: quantity, productId, didError: !added.ok } });
    else location.reload();
    if (added.ok) b.dispatchEvent(new CustomEvent('k4u:added', { bubbles: true }));
  } catch (error) {
    deferred?.reject(error);
  }
  b.disabled = false;
  b.removeAttribute('aria-busy');
});
